.new-event-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #111;
    width: 400px;
    min-width: 400px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.2);
    color: #e0e0e0;
}

.new-event-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: #111;
}

.new-event-header h2 {
    font-size: 18px;
    font-weight: 500;
    color: #e0e0e0;
    margin: 0;
}

.close-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #aaa;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.close-btn:hover {
    background: #222;
    color: #fff;
}

.new-event-scroll-area {
    flex: 1;
    overflow-y: auto;
    padding: 0 24px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* Title Section */
.ne-section-main {
    margin-bottom: 8px;
}

/* Title Input */
.ne-title-input {
    width: 100%;
    font-size: 24px;
    font-weight: 400;
    border: none;
    border-bottom: 1px solid #444;
    padding: 8px 8px;
    color: #fff;
    background: #2a2a2a;
    border-radius: 4px;
    transition: border-bottom-color 0.2s;
    outline: none;
}

/* Time Picker Input */
.picker-input {
    border: 1px solid #444;
    border-radius: 4px;
    padding: 6px 8px;
    font-size: 13px;
    color: #e0e0e0;
    width: 100%;
    transition: all 0.2s;
    cursor: pointer;
    background-color: #2a2a2a;
}

.picker-input:hover {
    background-color: #333;
    border-color: #555;
}

/* Tags */
.ne-tag {
    background: #2a2a2a;
    color: #ccc;
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    border: 1px solid transparent;
}

.ne-tag:hover {
    background: #333;
    color: #fff;
    border-color: #555;
}

/* Textarea */
.ne-ghost-textarea {
    flex: 1;
    border: none;
    background: #2a2a2a;
    padding: 12px;
    font-size: 14px;
    color: #e0e0e0;
    border-radius: 8px;
    resize: vertical;
    min-height: 80px;
    font-family: inherit;
    margin-top: 4px;
}

/* Inline Actions */
.ne-inline-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #333;
}

.ne-right-btns {
    display: flex;
    gap: 12px;
}

.ne-btn-text {
    background: none;
    border: none;
    color: #aaa;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
}

.ne-btn-text:hover {
    background: #222;
    color: #fff;
}

.btn-cancel {
    padding: 8px 16px;
    background: transparent;
    border: 1px solid #444;
    border-radius: 4px;
    color: #ccc;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.2s;
}

.btn-cancel:hover {
    background: #222;
    border-color: #555;
}

.ne-title-input:focus {
    border-bottom: 2px solid #1a73e8;
}

/* Time Section */
.ne-section-time {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ne-row {
    display: flex;
    align-items: flex-start;
    /* Changed to start to handle multi-line content next to icon */
    gap: 16px;
    min-height: 40px;
}

.ne-row-align-top {
    align-items: flex-start;
}

.ne-icon {
    color: #5f6368;
    flex-shrink: 0;
    width: 20px;
    margin-top: 10px;
    /* Align with inputs roughly */
}

.ne-time-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ne-time-inputs {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
}

.ne-time-field {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.ne-time-field label {
    font-size: 11px;
    color: #5f6368;
    margin-bottom: 2px;
    font-weight: 500;
}



.ne-time-arrow {
    display: none;
}

/* Duration Tags */
.ne-duration-tags {
    display: flex;
    gap: 8px;
    margin-top: 4px;
}



.ne-tag.selected {
    background-color: #3b82f6 !important;
    color: white !important;
    border-color: #3b82f6 !important;
}

/* Details Section */
.ne-section-details {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
}

.ne-ghost-input,
.ne-ghost-select {
    flex: 1;
    border: none;
    background: transparent;
    padding: 8px 0;
    font-size: 14px;
    color: #3c4043;
    border-radius: 4px;
    transition: background 0.2s;
    margin-top: 4px;
    /* Align with icon */
}

.ne-ghost-input:hover,
.ne-ghost-select:hover {
    background: #f1f3f4;
    padding-left: 8px;
    margin-left: -8px;
}

.ne-ghost-input:focus,
.ne-ghost-select:focus {
    outline: none;
    background: #f1f3f4;
    padding-left: 8px;
    margin-left: -8px;
}



.ne-action-btn {
    background: #1a73e8;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
    margin-top: 4px;
}

.ne-action-btn:hover {
    background: #1967d2;
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3);
}

/* Footer */
/* btn-save preserved */
.btn-save {
    padding: 8px 24px;
    background: #1a73e8;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    box-shadow: 0 1px 2px rgba(60, 64, 67, 0.3);
    transition: all 0.2s;
}

.btn-save:hover {
    background: #1765cc;
    box-shadow: 0 1px 3px rgba(60, 64, 67, 0.4);
}

/* Guest Input & Tagging */
.ne-guests-input-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    width: 100%;
    max-width: 347px;
}

.ne-guest-tag {
    display: flex;
    align-items: center;
    background: #333;
    border-radius: 16px;
    padding: 2px 6px 2px 2px;
    gap: 6px;
    border: 1px solid #444;
}

.ne-guest-tag-avatar {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    object-fit: cover;
}

.ne-guest-tag-name {
    font-size: 12px;
    color: #eee;
}

.ne-guest-remove {
    cursor: pointer;
    color: #888;
    transition: color 0.2s;
}

.ne-guest-remove:hover {
    color: #fff;
}

.ne-suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #1a1a1a;
    border: 1px solid #333;
    border-radius: 6px;
    margin-top: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 50;
    max-height: 200px;
    overflow-y: auto;
}

.ne-suggestion-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    cursor: pointer;
    transition: background 0.2s;
}

.ne-suggestion-item:hover {
    background: #2a2a2a;
}

.ne-suggestion-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    object-fit: cover;
}

.ne-suggestion-info {
    display: flex;
    flex-direction: column;
}

.ne-suggestion-name {
    font-size: 13px;
    color: #eee;
}

.ne-suggestion-email {
    font-size: 11px;
    color: #888;
}